import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Divider, Flex, Text } from '@mantine/core';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	instruction: string | null;
	title: string;
}

const InstructionsCard = ({ instruction, title, className }: Props) => {
	const tInvestor = useTranslationInvestor();

	return (
		<div className={className}>
			<Flex direction="column" gap="0.25rem">
				<Text fw={600}>{tInvestor('investment.join.kyc.instruction_for')}</Text>
				<Text>{title}</Text>
			</Flex>
			<Divider />
			<Text>{instruction}</Text>
		</div>
	);
};

const Memoized = memo(InstructionsCard);
const Styled = styled(Memoized)`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1rem;
	border: 1px solid ${(props) => props.theme.v3.colors.gray[4]};
	border-radius: 4px 4px 0 0;
	box-shadow: 0 4px 8px 0 #b8bfc2;
`;

export { Styled as InstructionsCard };
